import { useState } from 'react';

export function useInputValue(
  initialValue: any,
  initialIcon = '',
  initialStatus = 'normal',
  initialWarningMessage = '',
  initialType = 'text',
  initialWarningTitle = '',
) {
  const [warningTitle, setWarningTitle] = useState(initialWarningTitle);
  const [warningMessage, setWarning] = useState(initialWarningMessage);
  const [status, setStatus] = useState(initialStatus);
  const [value, setValue] = useState(initialValue);
  const [icon, setIcon] = useState(initialIcon);
  const [type, setType] = useState(initialType);

  function onChange(e: any) {
    setValue(e.target.value);
  }

  function HandleIcon(e: string) {
    setIcon(e);
  }

  function HandleStatus(e: string) {
    setStatus(e);
  }

  function HandleWarning(e: any) {
    setWarning(e);
  }

  function HandleType(e: string) {
    setType(e);
  }

  function HandleValue(e: string) {
    setValue(e);
  }

  function HandleWarningTitle(e: string) {
    setWarningTitle(e);
  }

  return {
    value,
    onChange,
    icon,
    status,
    warningMessage,
    HandleIcon,
    HandleStatus,
    HandleWarning,
    HandleType,
    type,
    HandleValue,
    warningTitle,
    HandleWarningTitle,
  };
}
